<template>
    <div>
        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="isFullPage">
        </loading>
    </div>
</template>

<script>
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css'

    export default {
        components: {
            Loading
        },
        props: {
            isLoading: {
                default: false
            },
            isFullPage: {
                default: false
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/mixins/components/Loading.vue